"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["href", "children", "className"];

var Link = function Link(props) {
  var href = props.href,
      children = props.children,
      className = props.className,
      rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledLink, (0, _extends2["default"])({
    target: "_blank",
    rel: "noopener noreferrer",
    className: className,
    href: href
  }, rest), children);
};

exports.Link = Link;

var StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-px97kb-0"
})(["color:#007aff;text-decoration:none;"]);